<template>
  <div class="p-16px">
    <el-form inline class="mb-12px">
      <el-form-item label="机构 ID">
        <el-input v-model="orgId" class="!w-140px" />
      </el-form-item>
      <el-button type="primary" @click="refresh">刷新</el-button>
    </el-form>
    <el-row :gutter="16">
      <el-col :span="8">
        <el-card shadow="never">
          <div class="text-13px text-[var(--el-text-color-secondary)]">机构状态</div>
          <div class="mt-8px text-20px font-600">{{ org?.status || '—' }}</div>
          <div class="mt-4px text-13px">{{ org?.name || orgId }}</div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="never">
          <div class="text-13px text-[var(--el-text-color-secondary)]">待审入驻</div>
          <div class="mt-8px text-20px font-600">{{ pendingCount }}</div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="never">
          <div class="text-13px text-[var(--el-text-color-secondary)]">当前邀请码</div>
          <div class="mt-8px text-20px font-600">{{ org?.inviteCode || '—' }}</div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script lang="ts" setup>
import * as OrgConsoleApi from '@/api/capacity/org-console'

defineOptions({ name: 'MerchantCapacityDashboard' })

const orgId = ref(localStorage.getItem('capacityOrgId') || '')
const org = ref<OrgConsoleApi.OrgItem>()
const pendingCount = ref(0)

const refresh = async () => {
  if (!orgId.value) {
    orgId.value = localStorage.getItem('capacityOrgId') || ''
  }
  if (!orgId.value) {
    org.value = undefined
    pendingCount.value = 0
    return
  }
  try {
    org.value = await OrgConsoleApi.orgInvite(orgId.value)
  } catch {
    org.value = undefined
  }
  try {
    const joins = await OrgConsoleApi.orgJoins(orgId.value, true)
    pendingCount.value = joins.length
  } catch {
    pendingCount.value = 0
  }
}

onMounted(refresh)
</script>
